import { getErrorStatus } from '../getErrorStatus/getErrorStatus';

export type ErrorCategory = 'notFound' | 'forbidden' | 'server' | 'network' | 'generic';

// Duck-types the AxiosError shape (ErrorType<Error> = AxiosError) so `features`
// doesn't need to depend on axios or the `api` package. The network checks mirror
// the `isNetworkError` guard in `api` (ERR_NETWORK / ECONNABORTED / 'Network Error').
export const getErrorCategory = (error: unknown): ErrorCategory => {
  if (typeof error !== 'object' || error === null) {
    return 'generic';
  }

  const err = error as {
    code?: unknown;
    message?: unknown;
  };

  const status = getErrorStatus(error);

  if (status === 404) {
    return 'notFound';
  }

  if (status === 403) {
    return 'forbidden';
  }

  if (typeof status === 'number' && status >= 500) {
    return 'server';
  }

  const isNetworkError =
    err.code === 'ERR_NETWORK' ||
    err.code === 'ECONNABORTED' ||
    err.message === 'Network Error' ||
    (typeof navigator !== 'undefined' && navigator.onLine === false);

  if (status === undefined && isNetworkError) {
    return 'network';
  }

  return 'generic';
};
